<template>
    <div v-html="html"></div>
</template>

<script>
const toNumber = (value, fallback) => {
    const num = Number(value);
    return Number.isFinite(num) ? num : fallback;
};

export const buildDefaultHtml = (props = {}) => {
    const align = props.align || 'left';
    const size = toNumber(props.size, 28);
    const gap = toNumber(props.gap, 8);
    const items = Array.isArray(props.items) ? props.items : [];
    const html = items.map((item, index) => {
        const url = item.url || '#';
        const iconUrl = item.iconUrl || '';
        const label = item.label || 'Red';
        const margin = index === items.length - 1 ? 0 : gap;
        if (iconUrl) {
            return `<a href="${url}" style="display:inline-block;margin-right:${margin}px;"><img src="${iconUrl}" alt="${label}" style="width:${size}px;height:${size}px;border:0;" /></a>`;
        }
        return `<a href="${url}" style="display:inline-block;margin-right:${margin}px;">${label}</a>`;
    }).join('');
    return `<div style="text-align:${align};">${html}</div>`;
};

export default {
    name: 'MailingBlockSocials',
    props: {
        html: { type: String, default: '' },
    },
};
</script>
